// 계정 관리 관련 API 함수들
import apiClient from "@services/api/apiClient.jsx";

const accountApi = {
    // 사용자 목록 조회 (페이징, 정렬 포함)
    getAccounts: async (page = 0, size = 10, sort = "createdAt,desc") => {
        try {
            const response = await apiClient.get(`/accounts`,
                {
                    params: { page, size, sort },
                }
            );
            return response.data.data;
        } catch (error) {
            console.error("사용자 목록 조회 실패:", error);
            throw error;
        }
    },

    // 사용자 상세 정보 조회
    getAccountById: async (accountId) => {
        try {
            const response = await apiClient.get(`/accounts/${accountId}`);
            return response.data.data;
        } catch (error) {
            console.error("사용자 상세 정보 조회 실패:", error);
            throw error;
        }
    },

    // 사용자 정보 수정
    updateAccount: async (accountId, accountData) => {
        try {
            const response = await apiClient.put(
                `/accounts/${accountId}`,
                accountData
            );
            return response.data.data;
        } catch (error) {
            console.error("사용자 정보 수정 실패:", error);
            throw error;
        }
    },

    // 사용자 삭제
    deleteAccount: async (accountId, accountData) => {
        try {
            const response = await apiClient.delete(`/accounts/${accountId}`, {
                data: accountData
            });
            return response.data;
        } catch (error) {
            console.error("사용자 삭제 실패:", error);
            throw error;
        }
    },
};

export default accountApi;
